import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartCtx = createContext(null);
const KEY = "nl_inquiry_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(KEY) || "[]");
      setItems(stored);
    } catch { /* empty */ }
  }, []);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1, selectedCatalogNumber = null, selectedPackSize = null) => {
    const normalizedCatalogNumber = selectedCatalogNumber ?? null;
    const normalizedPackSize = selectedPackSize ?? null;
    const lineId = normalizedCatalogNumber ? `${product.id}::${normalizedCatalogNumber}` : String(product.id);
    setItems((prev) => {
      const existing = prev.find((i) => i.line_id === lineId);
      if (existing) {
        return prev.map((i) =>
          i.line_id === lineId ? { ...i, quantity: i.quantity + qty } : i
        );
      }
      return [
        ...prev,
        {
          line_id: lineId,
          product_id: product.id,
          name: product.name,
          catalogNumber: normalizedCatalogNumber || product.catalogNumber,
          quantity: qty,
          image: product.images?.[0] || "",
          selectedCatalogNumber: normalizedCatalogNumber,
          selectedPackSize: normalizedPackSize,
        },
      ];
    });
    setOpen(true);
  };
  const remove = (line_id) =>
    setItems((p) => p.filter((i) => i.line_id !== line_id));

  const setQty = (line_id, qty) =>
    setItems((p) =>
      p.map((i) =>
        i.line_id === line_id ? { ...i, quantity: Math.max(1, qty) } : i
      )
    );

  const clear = () => setItems([]);

  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
